<template>
  <Container type="card-full">
    <div slot="header">
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div>
      <!-- <div class="split-box">
        <div class="split-line"></div>
        <div class="split-name">【缴费信息】</div>
      </div> -->
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目编号</div>
              <div class="view-value">{{psu.projectcode}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目名称</div>
              <div class="view-content">{{psu.projectname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">供应商</div>
              <div class="view-value">{{psu.comfullname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">信用代码</div>
              <div class="view-value">{{psu.comidcode}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">单位地址</div>
              <div class="view-value">{{psu.comaddr}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">开户银行</div>
              <div class="view-value">{{psu.combank}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">开户账号</div>
              <div class="view-value">{{psu.combanknumber}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">开票备注</div>
              <div class="view-value">{{psu.psuInvoicmark}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名联系人</div>
              <div class="view-value">{{psu.psucontactname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名电话</div>
              <div class="view-value">{{psu.psucontactphone}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">单位电话</div>
              <div class="view-value">{{psu.comtel}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">联系邮箱</div>
              <div class="view-value">{{psu.psucontactmail}}</div>
            </div>
          </div>
          <div class="split-box" v-if="+psu.psubidflg === 1">
            <div class="split-line"></div>
            <div class="split-name">【电子合同】</div>
          </div>
          <!-- 合同 -->
          <div class="view-row" v-if="+psu.psubidflg === 1">
            <div class="view-field">
              <div class="view-label">电子合同</div>
              <div style="color: #2f74ff;cursor: pointer;"
                      @click="downFile(append.appendurl)" v-if="append">
                    <a :src="$store.getters.uploadAddr + append.appendurl">{{append.appendfilename}}</a>
              </div>
              <div v-else class="view-value">无</div>
            </div>
          </div>
          <div class="split-box">
            <div class="split-line"></div>
            <div class="split-name">【缴费信息】</div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">保证金</div>
              <div class="view-value">{{setThousand(psu.projectbzjamt)}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">支付方式</div>
              <div class="view-value">{{Number(psu.psubzjpaytype) === 3 ? '线下支付' : (Number(psu.psubzjpaytype) === 1 ? '支付宝支付':'微信支付')}}</div>
            </div>
          </div>
          <div class="view-row" v-if="psu.psubzjpaytype != 3">
            <div class="view-field">
              <div class="view-label">交易单号</div>
              <div class="view-value">{{psu.psubzjpaytradeno}}</div>
            </div>
          </div>
          <div class="view-row"  v-if="Number(psu.psubzjpaytype) === 3">
            <div class="view-field">
              <div class="view-label">支付凭证</div>
              <div class="view-value">
                  <popover-img :img-src="psu.psubzjpayurl ? uploadAddr + psu.psubzjpayurl:''"
                               default-height="150"></popover-img>
                  <!--<upload-pic-one @changed='setfile' :picUrl='psu.psubzjpayurl' folderName='web' text="选择图片"></upload-pic-one>-->
              </div>
            </div>
          </div>
          <div class="view-row" v-if="!psu.psubzjpayflg">
            <div class="view-field form">
              <div class="view-label">是否缴费</div>
              <div class="view-value">
                <el-radio-group v-model="psubzjpayflg">
                  <el-radio :label="1">已收</el-radio>
                  <el-radio :label="2">未收</el-radio>
                </el-radio-group>
              </div>
              <div><el-button type="primary" @click="confirm" :loading="btnLoading">保存</el-button></div>
            </div>
          </div>
          <div class="view-row" v-if="+psu.psubzjpayflg === 1 || +psu.psubzjpayflg === 2">
            <div class="view-field">
              <div class="view-label">收款状态</div>
              <div class="view-value">{{+psu.psubzjpayflg===1 ? '已收':'未收'}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">收款人</div>
              <div class="view-value">
                <div v-if="+psu.psubzjpaytype === 1 || +psu.psubzjpaytype === 2">
                  线上支付
                </div>
                <div v-else>
                  {{psu.psubzjpaycheckusername}}
                </div>
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">收款时间</div>
              <div class="view-value">{{psu.psubzjpaychecktime}}</div>
            </div>
          </div>
          <div v-if="+psu.psubzjpayflg === 1">
          <div class="split-box">
            <div class="split-line"></div>
            <div class="split-name">【退款信息】</div>
          </div>
          <div class="view-row" v-if="+psu.psubzjpaytype === 3">
            <div class="view-field" >
              <div class="view-label">退回凭证</div>
              <div class="view-value">
                <div v-if="+psu.psubzjreturnflg === 1">
                  <div v-if="psu.psubzjreturnurl">
                    <popover-img :img-src="psu.psubzjreturnurl ? uploadAddr + psu.psubzjreturnurl:''"
                               default-height="150"></popover-img>
                  </div>
                  <div v-else>无</div>
                </div>
                <div v-else>
                  <upload-pic-one @changed='setfile_return' :picUrl='psu.psubzjreturnurl' folderName='web' text="选择图片"></upload-pic-one>
                </div>
              </div>
              <div v-if="+psu.psubzjreturnflg !== 1"><el-button type="primary" @click="returnSave" :loading="btnLoading">退回保证金</el-button></div>
            </div>
          </div>
          <div class="view-row" v-if="+psu.psubzjpaytype !== 3">
            <div class="view-field" >
              <div class="view-label"></div>
              <div class="view-value">
                <el-button type="primary" v-if="+psu.psubzjreturnflg != 1" @click="returnbzj" :loading="btnLoading">原路退回保证金</el-button>
              </div>
            </div>
          </div>
          <div class="view-row" v-if="+psu.psubzjreturnflg === 1 && +psu.psubzjpaytype !== 3">
            <div class="view-field" >
              <div class="view-label">退回单号</div>
              <div class="view-value">{{psu.psubzjreturntradeno}}</div>
            </div>
          </div>
          <div class="view-row"  v-if="+psu.psubzjreturnflg === 1">
            <div class="view-field" >
              <div class="view-label">退回状态</div>
              <div class="view-value">
                {{+psu.psubzjreturnflg === 1 ? '已退回':'未退回'}}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">退回确认人</div>
              <div class="view-value">{{psu.psubzjreturnusername}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">退回时间</div>
              <div class="view-value">{{psu.psubzjreturntime | newDate}}</div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import popoverImg from '../common/popoverImg'
  import common from '@/mixin/common'
  import dayjs from 'dayjs'
  export default {
    name: "psuBzjAffirmForm",
    mixins: [common],
    data () {
      return {
        psubzjpayflg: '',
        append:{},
        psu: {},
        returnpay:{},
        type: Number(this.$route.params.type),
        btnLoading: false
      }
    },
    created () {
    },
    activated () {
      this.getpageInfo()
      this.init()

    },
    deactivated () {
      this.$destroy()
    },
    mounted(){
    },
    watch: {},
    filters: {
      newDate(value){
        return utils.formatterDate(value, 'yyyy-MM-dd HH:mm:ss')
      }
    },
    components: {uploadPicOne, popoverImg},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      async setfile_return (path) {
        this.psu.psubzjreturnurl = path.replace(this.uploadAddr, '')
      },
      setThousand (value) {
        return utils.comdify(value)
      },
      btnClick (code) {
        this.$emit(code)
      },
      async init () {
        this.psu = {}
        this.btnLoading = false
      },
      async setfile (path) {
        this.psu.psubzjpayurl = path.replace(this.uploadAddr, '')
      },
      async getpageInfo(){
        let res = await request({
            method: 'get',
            url: '/cwgl/psuproject/getpageInfo',
            params: {psuid: this.$route.params.psuid}
        })
        this.psu = res[0]
        this.psu.psubzjpaychecktime = utils.formatterDate(res[0].psubzjpaychecktime,'yyyy-MM-dd HH:mm:ss')
        await this.getAppend()
      },
      async getAppend(){
          let res = await request({
            method:'get',
            url:'ywgl/append/getAppendListByFromId',
            params:{appendfromid:this.$route.params.psuid,appendfromtype:21}
          })
          this.Appendcount = res.length
          this.append = res[0]
      },
      async confirm(){
          this.loading = true
          if(+this.psubzjpayflg === 0){
            this.$message.warning('请先选择是否缴费')
            return
          }
          this.$confirm('是否确认?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            this.psu.psubzjpayflg = this.psubzjpayflg
            this.psu.psubzjpaycheckuserid = this.$store.getters.loginUser.userid
            let res = await request({
              method: 'post',
              url: '/cwgl/psuproject/checkbzjpay',
              data: this.psu
            })
            if (res.issuccess === 1) {
              this.$message.success('保证金确认成功')
              await this.getpageInfo()
            } else {
              this.$message.error('保证金确认失败')
            }
            }).catch(() => {
          })
          this.loading = false
      },
      async returnSave () {
        let msg = ''
        if(+this.psu.projectstopflg || +this.psu.projectcancelflg){
          msg = '是否确认退回保证金。'
        } else {
          if(+this.psu.psubidflg === 1 && +this.psu.psufewreceive !== 1){
            this.$message.warning('该用户未缴纳服务费，不能退回保证金')
            return
          } 
          if(+this.psu.psubidflg === 1 && +this.psu.psufewreceive === 1){
            msg = '是否确认退回保证金。'
          } else if(+this.psu.psubidflgcount === 0){
            msg = '项目还未结束，是否确认退回保证金。'
          } else if (+this.psu.psubidflgcount > 0 && +this.psu.psubidflg === 1 && +this.psu.psufeepaytype === 0 && +this.psu.psufewreceive !== 1){
            msg = '该用户未缴纳服务费，是否确认退回保证金。'
          } else if(+this.psu.psubidflgcount > 0){
            msg = '是否确认退回保证金。'
          }
        }
        this.$confirm(`${msg}`, '保证金退回', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.btnLoading = true
          this.psu.psubzjreturnuserid = this.$store.getters.loginUser.userid
          this.psu.psubzjreturnflg = 1
          let data = await request({
            url: '/xmgl/project/savePsuBzjRetuen',
            method: "post",
            data: this.psu
          })
          if (data.issuccess === 1) {
            await this.getpageInfo()
            this.beingPush()
            this.$message.success('保证金退回成功')
          } else {
            this.$message.error('保证金退回失败')
          }
          this.btnLoading = false
        }).catch(() => {
        })
      },
      async beingPush(){
        let model = {}
        model.psuid = this.psu.psuid
        model.projectid = this.psu.projectid
        model.psuuserid = this.psu.psuuserid
        model.cosid =  this.$store.getters.loginUser.cosid
        model.paytype = this.psu.psubzjpaytype
        let data = await request({
          method: 'get',
          url: '/info/rush/returnRemind',
          params: model
        })
      },
      async returnbzj(){
        if(+this.psu.psubzjreturnflg === 1){
          this.$message.warning('保证金已退回')
          return
        }
        
        let msg = ''
        if(+this.psu.projectstopflg || +this.psu.projectcancelflg){
          msg = '是否确认退回保证金。'
        } else {
          if(+this.psu.psubidflg === 1 && +this.psu.psufewreceive !== 1){
            this.$message.warning('该用户未缴纳服务费，不能退回保证金')
            return
          }
          if(+this.psu.psubidflgcount === 0){
            msg = '项目还未结束，是否确认退回保证金。'
          } else if (+this.psu.psubidflgcount > 0 && +this.psu.psubidflg === 1 && +this.psu.psufeepaytype === 0 && +this.psu.psufewreceive !== 1){
            msg = '该用户未缴纳服务费，是否确认退回保证金。'
          }else if(+this.psu.psubidflgcount > 0){
            msg = '是否确认退回保证金。'
          }
        }

        this.$confirm(`${msg}`, '保证金退回', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.btnLoading = true
          this.returnpay.returnMoneyType = 2
          this.returnpay.type = Number(this.psu.psubzjpaytype)
          this.returnpay.out_trade_no = this.psu.psubzjpayno  //out_trade_no: '商户内部订单号',
          this.returnpay.out_refund_no = this.psu.psubzjpaytradeno // out_refund_no: '商户内部退款单号'
          this.returnpay.cosmerchantNumber = this.$store.state.user.loginUser.cosmerchantNumber
          this.returnpay.coswxPublicAccountId = this.$store.state.user.loginUser.coswxPublicAccountId
          this.returnpay.coswxPublicKey = this.$store.state.user.loginUser.coswxPublicKey
          this.returnpay.coswxSecurityPrivateKey = this.$store.state.user.loginUser.coswxSecurityPrivateKey
          this.returnpay.cosalipayApplicationId = this.$store.state.user.loginUser.cosalipayApplicationId
          this.returnpay.cosalipayPublicKey = this.$store.state.user.loginUser.cosalipayPublicKey
          this.returnpay.cosalipayPrivateKey = this.$store.state.user.loginUser.cosalipayPrivateKey
          if(Number(this.psu.psubzjpaytype) === 1){
            this.returnpay.total_fee = this.psu.projectbzjamt
            this.returnpay.refund_fee = this.psu.projectbzjamt
          }
          else if(Number(this.psu.psubzjpaytype) === 2){
            this.returnpay.total_fee = this.psu.projectbzjamt * 100
            this.returnpay.refund_fee = this.psu.projectbzjamt * 100
          }
          this.returnpay.psuid = this.psu.psuid
          this.returnpay.projectid = this.psu.projectid
          this.returnpay.cosid = this.psu.projectcosid
          this.returnpay.psubzjreturnflg = 1
          this.returnpay.psubzjreturnuserid = this.$store.getters.loginUser.userid
          
          let data = await request({
            url: '/common/refund',
            method: "post",
            data: this.returnpay
          })
          this.getpageInfo()
          this.$message.success(data['issuccess'])
          this.beingPush()
          this.btnLoading = false
          return
        }).catch(() => {
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form {
    display: flex;
    align-items: center;
  }
  .split-box{
    margin: 11px 0 15px;
    .split-line{
      margin: 5px;
    }
    .split-name{
      font-weight: bold;
    }
  }
</style>
